import { Button, Card, Grid, IconButton, Paper } from '@mui/material';
import CardHeader from '../../components/Card/CardHeader';

import { Add } from '@material-ui/icons';
import MotiveLogo from './connectors/Motive/logo';
import { useHistory } from 'react-router-dom';
import bcLogo from './connectors/businessCentral/logo.png';
import IntegrationInfoDialog from './IntegrationInfoDialog';
import { useState } from 'react';
import mcpLogo from './connectors/MCP/logo.png';

export default function IntegrationPage() {
  const history = useHistory();
  const [integrationNameToDisplayInfo, setIntegrationNameToDisplayInfo] = useState<string>();
  const connect = (connector: string) => {
    history.push(`integrations/${connector}`);
  };
  const handleIntegrationInfoClose = () => {
    setIntegrationNameToDisplayInfo(undefined);
  };
  return (
    <>
      <Card>
        <CardHeader color="primary" style={{ marginTop: 8 }}>
          <Grid container>
            <Grid item flexGrow={1}>
              Integrations
            </Grid>
            <Grid item>
              <IconButton size="small">
                <Add style={{ color: 'white' }} />
              </IconButton>
            </Grid>
          </Grid>
        </CardHeader>

        <Paper>
          <Grid container p={2} spacing={2} alignItems="stretch">
            <Grid item xs={12} md={6} lg={4}>
              <Card style={{ height: '100%', display: 'flex', flexDirection: 'column', padding: 16 }}>
                <div style={{ paddingBottom: 16 }}>
                  <img src={mcpLogo} alt="MCP" style={{ height: 40, marginBottom: 5, marginTop: 5 }} />
                </div>
                <div style={{ flexGrow: 1 }}>
                  Connect to AI models and tools through Model Context Protocol (MCP) servers to enhance your workflow
                  with intelligent automation.
                </div>
                <div style={{ textAlign: 'right' }}>
                  <Button
                    onClick={() => {
                      connect('MCP');
                    }}
                  >
                    Manage
                  </Button>
                </div>
              </Card>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <Card style={{ height: '100%', display: 'flex', flexDirection: 'column', padding: 16 }}>
                <div style={{ paddingBottom: 16 }}>
                  <MotiveLogo />
                </div>
                <div style={{ flexGrow: 1 }}>
                  Motive is a technology company that creates hardware and software to improve the safety and
                  productivity of physical operations. Motive serves a wide range of industries including transportation
                  and logistics, construction, energy, field service, manufacturing, agriculture, food and beverage,
                  passenger transit, retail, and the public sector.
                </div>
                <div style={{ textAlign: 'right' }}>
                  <Button
                    onClick={() => {
                      connect('motive');
                    }}
                  >
                    Connect
                  </Button>
                </div>
              </Card>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <Card style={{ height: '100%', display: 'flex', flexDirection: 'column', padding: 16 }}>
                <div style={{ paddingBottom: 16 }}>
                  <img src={bcLogo} alt="Business Central" style={{ height: 50 }} />
                </div>
                <div style={{ flexGrow: 1 }}>
                  Microsoft Dynamics 365 Business Central is a comprehensive business management solution for small and
                  medium-sized businesses.
                </div>
                <Grid container justifyContent="space-between">
                  <Button
                    onClick={() => {
                      setIntegrationNameToDisplayInfo('businessCentral');
                    }}
                    color="success"
                  >
                    Info
                  </Button>
                  <Button
                    onClick={() => {
                      connect('businessCentral');
                    }}
                  >
                    Connect
                  </Button>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </Paper>
      </Card>
      <IntegrationInfoDialog name={integrationNameToDisplayInfo} onClose={handleIntegrationInfoClose} />
    </>
  );
}
